// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"5858fdd6","709":"cdb86a1b","809":"eb413fe2"}[chunkId] + ".chunk.js";
};